import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext";
import DeleteDialogIcon from "@entrilia/shared/icons/DeleteDialogIcon";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../../../api/adminApi";

interface Props {
  categoryId: string;
  categoryName: string;
  onClose: () => void;
  onDeleted: () => void;
}

const deleteFundraisingCategory = withErrorHandling(adminApi.deleteFundraisingCategory);

const DeleteCategoryConfirmationDialog = ({ categoryId, categoryName, onClose, onDeleted }: Props) => {
  const { sendNotificationError } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const handleDeleteClick = async () => {
    setLoading(true);
    const [, error] = await deleteFundraisingCategory(categoryId);
    setLoading(false);

    if (error) {
      logError(error, "[DeleteCategoryConfirmationDialog]");
      sendNotificationError(error.message);
      return;
    }

    onDeleted();
  };

  return (
    <SmallDialog open onClose={onClose}>
      <DialogTitle>Delete</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <DeleteDialogIcon sx={{ width: 80, height: 80 }} />
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Typography variant="h6">Delete category?</Typography>
            <Typography color="textSecondary" sx={{ textAlign: "center" }}>
              You&apos;re about to delete category <strong>{categoryName}</strong>. This action will remove the category
              from all fundraisings and revoke access to any documents assigned to it.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="outlined" color="error" loading={loading} onClick={handleDeleteClick}>
          Delete
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default DeleteCategoryConfirmationDialog;
